import { Box, CircularProgress } from "@mui/material";
import React, { useEffect, useState } from "react";
import { withTheme } from "styled-components";

import { atomicConfig } from "../../config";
import { call_api_auth } from "../../utils/services";

const NicheAnalysis = () => {
  const [iframeUrl, setIframeUrl] = useState(null);
  const [error, setError] = useState(null);

  useEffect(() => {
    const fetchEmbedUrl = async () => {
      try {
        const response = await call_api_auth(
          atomicConfig.storeManagementServiceUrl + "/metabase/embed-url",
          "POST",
          { dashboardId: 6 }
        );
        setIframeUrl(response.data.iframeUrl);
      } catch (err) {
        setError("Failed to load dashboard");
      }
    };
    fetchEmbedUrl();
  }, []);

  if (error) return <Box p={4}>{error}</Box>;
  if (!iframeUrl)
    return (
      <Box display="flex" justifyContent="center" alignItems="center" p={4}>
        <CircularProgress />
      </Box>
    );

  return (
    <React.Fragment>
      <iframe
        src={iframeUrl}
        title="Niche analysis"
        frameBorder="0"
        width="100%"
        height="100%"
        allowTransparency="true"
      />
    </React.Fragment>
  );
};

export default withTheme(NicheAnalysis);
